'use client'

import useSWR from 'swr'
import { useTranslations } from 'next-intl'
import { useParams } from 'next/navigation'

import { ApiRoutes } from '@/api/routes'
import { fetcher } from '@/api/functions'
import LoadingCard from './components/LoadingCard'
import RepresentativesCard from './components/RepresentativesCard'

import { IFetchedDataRoot, IRepresentationsData } from '@/types'

const Representatives = () => {
  const params = useParams()
  const t = useTranslations('ContactsPage')
  const { data: representatives, isLoading } = useSWR<IFetchedDataRoot<IRepresentationsData>>(
    ApiRoutes.company.representations + '/?lang=' + params.locale,
    fetcher
  )

  return (
    <section>
      <h2 className="mb-6 md:mb-[45px]">{t('OurRepresentatives')}</h2>
      <div className="flex flex-col gap-4">
        {isLoading
          ? [1, 2, 3].map((val) => <LoadingCard key={'loading-representations-card-' + val} />)
          : representatives?.results.map((data) => (
              <RepresentativesCard key={'representations-item-' + data.id} {...data} />
            ))}
      </div>
    </section>
  )
}

export default Representatives
